<script>
	import { onMount } from 'svelte';
	import {getCookie, setCookie} from './Utils.svelte';
	import { locale } from 'svelte-i18n';

	export let selected = "us";

	const flags = [
		{ language: "Poland", id: "pl" },
		{ language: "English", id: "us" },
	];
	function handleClick(lang_id) {
		selected = lang_id;
		locale.set(selected);
		setCookie("userLang", selected);
	};

	onMount(async () => {
		let lang = getCookie("userLang");

		if ( lang !== null ) {
			selected = lang;
			locale.set(selected);
			return;
		}

		let result = await fetch('https://www.cloudflare.com/cdn-cgi/trace');
		let res_text = await result.text();
		let n = res_text.search('loc=');
		let localization = res_text.substr(n+4, 2).toLowerCase();

		if (flags.find(flag => flag.id === localization)) {
			selected = localization;
		} else{
			selected = "us";
		}

		locale.set(selected);
		setCookie("userLang", selected);
	});

</script>

<div>
	<span>
		{#each flags as flag}
			<p on:click={() => handleClick(flag.id)}>
				<img src="flags/{flag.id}.svg" 
				 alt="{flag.language}" 
				 width=30px 
	 			 class="{selected === flag.id ? 'active' : ''}">
			</p>
		{/each}
	</span>
</div>

<style>
	div {
		margin-top: 10px;
		margin-right: 30px;
	}
	img {
		margin-left: 10px;
		float: right;
	}

	.active {
		box-shadow: 0px 0px 4px 4px RGBA(255,255,255,0.6);
	}
</style>
